import { Helmet } from "react-helmet";
import PublicHeader from "../components/layout/public-header/PublicHeader";
import useAppDetail from "./hooks/useAppDetail";
import styles from "./styles/AppDetailPage.module.css";

const AppDetailPage = () => {
  const { app, loading, notFound } = useAppDetail();

  return (
    <div className={styles.page}>
      <PublicHeader links={[
        { label: "Home", to: "/" },
        { label: "About", to: "/" },
        { label: "Contact", to: "/" },
      ]} />

      {loading && (
        <div className={styles.notFound}>
          <p>Loading...</p>
        </div>
      )}

      {!loading && notFound && (
        <div className={styles.notFound}>
          <h2>App not found</h2>
        </div>
      )}

      {!loading && app && (
        <Helmet>
          <title>{app.name} | Xeniapps</title>
          <meta name="description" content={app.tagline || `${app.name} — built by Marco Zak Ciuffini, freelance React Native developer.`} />
          <link rel="canonical" href={`https://www.xeniapps.com/apps/${app.slug}`} />
        </Helmet>
      )}
      {!loading && app && (
        <div className={styles.content}>
          <div className={styles.appHeader}>
            {app.icon_url ? (
              <img src={app.icon_url} alt={app.name} className={styles.icon} />
            ) : (
              <div className={styles.iconPlaceholder}>📱</div>
            )}
            <div className={styles.appMeta}>
              <h1 className={styles.appName}>{app.name}</h1>
              {app.tagline && <p className={styles.appTagline}>{app.tagline}</p>}
              {app.status === "coming_soon" && (
                <span className={styles.badgeSoon}>Coming soon</span>
              )}
            </div>
          </div>

          {app.description && (
            <>
              <hr className={styles.divider} />
              <p className={styles.description}>{app.description}</p>
            </>
          )}

          {app.status === "live" && (app.app_store_url || app.play_store_url || app.download_url) && (
            <>
              <hr className={styles.divider} />
              <div className={styles.downloadSection}>
                <p className={styles.sectionLabel}>Download</p>

                {app.app_store_url && (
                  <a href={app.app_store_url} target="_blank" rel="noreferrer" className={styles.storeBtn}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                    </svg>
                    <div className={styles.storeBtnLabel}>
                      <small>Download on the</small>
                      App Store
                    </div>
                  </a>
                )}

                {app.play_store_url && (
                  <a href={app.play_store_url} target="_blank" rel="noreferrer" className={styles.storeBtn}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3 20.5v-17c0-.83.94-1.3 1.6-.8l14 8.5c.61.37.61 1.27 0 1.64l-14 8.5c-.66.5-1.6.03-1.6-.84z" />
                    </svg>
                    <div className={styles.storeBtnLabel}>
                      <small>Get it on</small>
                      Google Play
                    </div>
                  </a>
                )}

                {app.download_url && (
                  <a href={app.download_url} download className={styles.storeBtn}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M5 20h14v-2H5v2zm7-18v12l-4-4-1.4 1.4L12 17l5.4-5.6L16 10l-4 4V2h-2z" />
                    </svg>
                    <div className={styles.storeBtnLabel}>
                      <small>
                        {app.download_version
                          ? `Latest build · v${app.download_version}${app.download_updated_at ? ` · ${new Date(app.download_updated_at).toLocaleDateString("en-GB", { day: "numeric", month: "short" })}` : ""}`
                          : "Direct download"}
                      </small>
                      {app.download_label || "Download APK"}
                    </div>
                  </a>
                )}
              </div>
            </>
          )}
        </div>
      )}

      <footer className={styles.footer}>
        <p>© {new Date().getFullYear()} Xeniapps</p>
      </footer>
    </div>
  );
};

export default AppDetailPage;
